import { render, staticRenderFns } from "./PassEdit.vue?vue&type=template&id=d62b52d2&scoped=true&"
import script from "./PassEdit.vue?vue&type=script&lang=ts&"
export * from "./PassEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PassEdit.vue?vue&type=style&index=0&id=d62b52d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62b52d2",
  null
  
)

export default component.exports